// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vd__375O6","input":"vd__1tKCB","label":"vd__2SdC7"};